import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section className="bg-[#080808] py-28 overflow-hidden" id="about">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Text */}
          <div>
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              About DBN Garage
            </span>
            <h2 className="font-display font-black text-4xl lg:text-5xl text-white leading-tight mb-6">
              South Windsor's
              <br />
              <span className="text-[#FF6B35]">Premium Auto Protection</span>
              <br />
              Destination
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-5">
              DBN Garage is South Windsor, Connecticut's trusted destination for premium automotive protection and enhancement. With over 25 years of passion for cars and precision craftsmanship, we've built a reputation as the Hartford area's go-to specialists for <strong className="text-white">PPF</strong>, <strong className="text-white">ceramic coating</strong>, and <strong className="text-white">window tint</strong>.
            </p>
            <p className="text-gray-400 text-base leading-relaxed mb-5">
              As an XPEL-certified installer, we hold ourselves to the highest standard in the industry. We work exclusively with premium brands because your vehicle deserves nothing less. Whether it's a brand-new supercar or your daily driver, we treat every project with equal obsession.
            </p>
            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Located in South Windsor, CT, we proudly serve Hartford County and all surrounding communities. Our shop is built for the car enthusiast who demands perfection.
            </p>

            {/* Credential pills */}
            <div className="grid grid-cols-2 gap-3 mb-10">
              {[
                { icon: 'ri-award-fill', label: 'XPEL Certified Installer' },
                { icon: 'ri-history-fill', label: '25+ Years Experience' },
                { icon: 'ri-vip-diamond-fill', label: 'Premium Brands Only' },
                { icon: 'ri-focus-3-fill', label: 'Precision Application' },
              ].map((g) => (
                <div key={g.label} className="flex items-center gap-3 bg-[#111111] border border-white/10 rounded-xl px-4 py-3">
                  <span className="w-8 h-8 flex items-center justify-center bg-[#FF6B35]/15 rounded-lg flex-shrink-0">
                    <i className={`${g.icon} text-[#FF6B35] text-base`} />
                  </span>
                  <span className="text-white/80 text-sm font-semibold leading-tight">{g.label}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-4">
              <Link to="/about"
                className="inline-flex items-center gap-2 bg-white hover:bg-gray-100 text-[#0A0A0A] font-bold px-7 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
                Our Story
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
              </Link>
              <a href="tel:+18605550127" className="text-[#FF6B35] font-bold text-sm hover:underline cursor-pointer whitespace-nowrap">(860) 555-0127</a>
            </div>
          </div>

          {/* Image composition */}
          <div className="relative">
            <div className="absolute -top-5 -right-5 w-28 h-28 border border-[#FF6B35]/20 rounded-2xl" />
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-2xl overflow-hidden h-64">
                <img src="https://public.readdy.ai/ai/img_res/e019795db22e7da5d531f8a6919ead29.jpg"
                  alt="DBN Garage premium auto protection studio South Windsor CT"
                  className="w-full h-full object-cover object-top" />
              </div>
              <div className="rounded-2xl overflow-hidden h-64 mt-8">
                <img src="https://readdy.ai/api/search-image?query=close%20up%20paint%20protection%20film%20being%20applied%20to%20luxury%20car%20edge%20perfect%20installation%20professional%20precision%20auto%20protection%20dark%20studio%20cinematic&width=400&height=400&seq=about_auto2&orientation=squarish"
                  alt="Precision PPF installation process DBN Garage"
                  className="w-full h-full object-cover object-top" />
              </div>
              <div className="rounded-2xl overflow-hidden h-52">
                <img src="https://readdy.ai/api/search-image?query=ceramic%20coating%20application%20luxury%20black%20sports%20car%20perfect%20glass%20reflections%20professional%20auto%20detailer%20premium%20studio%20Connecticut&width=400&height=300&seq=about_auto3&orientation=landscape"
                  alt="Ceramic coating professional application"
                  className="w-full h-full object-cover object-top" />
              </div>
              <div className="bg-[#FF6B35] rounded-2xl h-52 flex flex-col items-center justify-center p-5 mt-0">
                <span className="font-display font-black text-4xl text-white">25+</span>
                <span className="text-white/80 text-sm font-semibold text-center mt-1">Years of Automotive Passion</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
